import React from 'react';
type SnakButtonProps = {
  children: React.ReactNode;
  onClick: () => void;
  variant?: 'solid' | 'outline';
  disabled?: boolean;
  className?: string;
};

/** Primary action inside the Caprelsa Snak (caprelsa.com styling: purple pill, gold hover). */
export function SnakButton({
  children,
  onClick,
  variant = 'solid',
  disabled = false,
  className = ''
}: SnakButtonProps) {
  const look = variant === 'solid' ? 'bg-cap-purple text-white hover:bg-cap-ink' : 'border-2 border-cap-purple/20 bg-white text-cap-purple hover:border-cap-purple';
  return <button type="button" onClick={onClick} disabled={disabled} className={`h-14 w-full rounded-full text-[13px] font-bold tracking-[0.12em] transition-[background-color,border-color,transform,opacity] duration-150 ease-out active:scale-[0.97] disabled:cursor-not-allowed disabled:opacity-35 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-cap-gold ${look} ${className}`} data-id="element-626" data-mp="rwftiqn1whgi">
      {children}
    </button>;
}